/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import Topic900Bg1 from '../../../../../../assets/cybersecurity2026/topic900/topic900_bg1.png';
import Topic900Bg2 from '../../../../../../assets/cybersecurity2026/topic900/topic900_bg2.png';
import { useStore } from '../../../../store';
import VideoTranscript from '../../components/VideoTranscript/index';
import { WTitle } from '../../components/Widget';
import useIntersectionObserver from '../../../../../../hooks/useIntersectionObserver';

interface ISection1Props {
  settings: any;
}

const Section0: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '1';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[0],
    [settings?.paragraphs]
  );
  const { updateParagraphState } = useStore();
  const { targetRef, isVisible } = useIntersectionObserver({
    threshold: 1, // 元素 30% 进入视口时触发
    rootMargin: '50px', // 根边距缩小 50px（需元素进入视口 50px 后才判定）
  });
  React.useEffect(() => {
    if (isVisible) {
      updateParagraphState(p_course, p_topic, ID, 'completed', []);
    }
  }, [isVisible]);
  React.useEffect(() => {
    const onPlay = () => {
      if (process.env.REACT_APP_HOST_TYPE === 'dev') {
        return;
      }
      const elem = document?.querySelector('#videoOcre');
      if (elem?.requestFullscreen) {
        try {
          elem.requestFullscreen();
        } catch (error) {
          console.log(error);
        }
        document
          ?.querySelector('#videoOcre')
          ?.removeEventListener('play', onPlay);
      }
    };
    document?.querySelector('#videoOcre')?.removeEventListener('play', onPlay);
    document
      ?.querySelector('#videoOcre')
      ?.addEventListener('play', onPlay, { passive: true });
    return () =>
      document
        ?.querySelector('#videoOcre')
        ?.removeEventListener('play', onPlay);
  }, []);
  return (
    <>
      <div className="education-landing course-landing">
        <div className="title-container">
          <WTitle title={paragraphsSettings.header} />
        </div>
        <div className="education-landing-text" ref={targetRef}>
          <div className="education-landing-tip">
            {isVisible && (
              <div className="education-landing-tip-title text-focus-in">
                {paragraphsSettings.description}
              </div>
            )}
          </div>
        </div>
        <div className="course-landing-content">
          <div className="education-landing-text course-landing-text">
            <div className="video_box">
              <div className="video-container">
                <video
                  id="videoOcre"
                  width="100%"
                  controls
                  autoPlay={process.env.REACT_APP_HOST_TYPE !== 'dev'}
                >
                  <source
                    src={paragraphsSettings?.landingVideo?.src}
                    type="video/mp4"
                  />
                  Your browser does not support HTML video.
                </video>
                <VideoTranscript transcripts={paragraphsSettings.transcripts} />
              </div>
            </div>
          </div>
        </div>
        <img src={Topic900Bg1} className="topic900-bg1" alt="" />
        <img src={Topic900Bg2} className="topic900-bg2" alt="" />
        <span className="topic900-h5-bg"></span>
      </div>
    </>
  );
};

export default Section0;
